define.alias("shared/components/shared/card", "settings/components/shared/card");